
function sanitize(str) {
  return str ? str.replace(/[^a-zA-Z0-9_-]/g, '').toLowerCase() : '';
}

export {
  sanitize
}